export default __webpack_public_path__ + "static/proj2-8245d89a7d0ab7c9b92fd29238c00bf9.jpg";